import * as tslib_1 from "tslib";
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from 'environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../authentication/authentication.service";
var BlatoutService = /** @class */ (function () {
    function BlatoutService(authenticationService) {
        this.authenticationService = authenticationService;
        this.blatOut = window['BlatOut'];
    }
    BlatoutService.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                user = this.authenticationService.user;
                if (!this.blatOut || !user) {
                    return [2 /*return*/];
                }
                this.blatOut.load({
                    app: {
                        id: environment.BLATOUT_APP_ID,
                        title: 'Fieldnews - Boletim de novidades do Field Control',
                    },
                    user: {
                        id: user.id,
                        hash: user.fieldNewsEmailHash,
                        email: user.email,
                        name: user.name
                    },
                    widgets: {
                        badge: {
                            type: 'counter',
                            selector: '#blatout-badge-counter'
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    BlatoutService.prototype.refresh = function () {
        if (!this.blatOut) {
            return;
        }
        this.blatOut.refresh();
    };
    BlatoutService.prototype.open = function () {
        if (!this.blatOut) {
            return;
        }
        this.blatOut.open();
    };
    BlatoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BlatoutService_Factory() { return new BlatoutService(i0.ɵɵinject(i1.AuthenticationService)); }, token: BlatoutService, providedIn: "root" });
    return BlatoutService;
}());
export { BlatoutService };
